import { Accordion, AccordionDetails, AccordionSummary, Switch, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(
  (theme) => ({
    accordion: {
      width: "100%",
      borderTop: `1px solid ${theme.palette.divider}`,
      "&:first-of-type": {
        borderTop: 0,
      },
      "&:last-of-type": {
        borderBottom: "10px solid red !important",
        background: "red"
      },
      '&::before': {
        display: 'none',
      },
      "& .MuiAccordionSummary-expandIconWrapper": {
        transform: "none !important",
      },
      "& .MuiAccordionSummary-root": {
        paddingRight: theme.spacing(1),
      }
    },
    last: {
      
      borderBottom: `1px solid ${theme.palette.divider}`,
    }
  })
);

export default function LayerSettings(props) {
  const { classes } = useStyles();

  return (
    <Accordion
      className={`${classes.accordion} ${props.last ? classes.last : ""}`}
      expanded={props.open}
      onChange={props.onChange}
      disableGutters elevation={0} square
    >
      <AccordionSummary expandIcon={<Switch checked={props.open}  />}>
        <Typography component="span" variant="subtitle2">{props.title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {props.children}
      </AccordionDetails>
    </Accordion>
  );
}

